var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-section__header-container"},[_c('app-divider'),_c('div',{staticClass:"app-section__header-title"},[_vm._t("default",[_vm._v("\n      Section Title\n    ")])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }